import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

interface AnalysisSeries {
  Data: { Timestamp: number; Value: number }[];
}

export interface AnalysisChartData {
  Series: Record<string, AnalysisSeries>;
}

export const fetchAnalysisChartData = createAsyncThunk(
  'pumpCheckerInstance/fetchAnalysisChartData',
  async ({ wellId, MOP }: { wellId: number; MOP: string }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/tests/GetAnalysisCharts/?wellId=${wellId}&mop=${MOP}`,
      );

      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching analysis chart data:', error);
      return [];
    }
  },
);
